// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/bde6c351270a46ab6814.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"53fc148a8d9848307480","136":"497d3508864c07855c06","137":"5aeb90640d039d3b0b45"}[chunkId] + ".chunk.js";
};